import React, {useState, useRef} from 'react'
import { Button, Form, FormGroup, Input, Label, Row, Col, Spinner, FormText } from 'reactstrap'
import useApiPrivate from '../../utils/hooks/useApiPrivate';
import { useOnChangeHandler } from '../../utils/hooks/useOnChangeHandler';
import { Toast } from 'primereact/toast';

const CHARGE_URL = 'api/v1/finances/charge';

export default function Charge() {
  const apiPrivate = useApiPrivate();
  const toast = useRef(null);


  const [isLoading, setIsLoading] = useState(false);
  
  const [amount, setAmount, onChangeHandlerAmount] = useOnChangeHandler('');

  const showSuccess = (message) => {
    toast.current.show({severity:'success', summary: 'Success', detail: message, life: 3000});
  }
  const showError = (message) => {
      toast.current.show({severity:'error', summary: 'Error', detail: message, life: 3000});
  }

  const handleChargeClick = async () => {
    setIsLoading(true);

    try{
        const response = await apiPrivate.get(CHARGE_URL,{
          params:{
            amount: amount && amount,
          }
        });
        setIsLoading(false);
        window.location.replace(response.data.data);
    }
    catch (error) {
      showError(error?.response?.data?.message)
      setIsLoading(false);
    }
    finally{
      setIsLoading(false);
    }
  }

  return (
    <>
      <Toast ref={toast} position="top-center" />
      <div className={`bg-white p-4 lgtBackground`}>
        <Row>
          <Col sm={12} md={12}>
            <p>
              Enter the amount to charge your wallet.
            </p>
          </Col>
        </Row>
        <Row>
          <Col sm={12} md={6}>
            <Form>
              <FormGroup floating>
                <Input
                  id="amount"
                  name="amount"
                  placeholder="Amount"
                  type="number" 
                  value={amount}
                  onChange={onChangeHandlerAmount}
                />
                <Label for='amount'>
                  Amount
                </Label>
                <FormText>
                  The amount must be between $10 to $1000.
                </FormText>
              </FormGroup>
            </Form>
            <div>
              <Button 
                disabled={!amount || isLoading ? true : false}
                onClick={handleChargeClick}
              >
                {
                  isLoading 
                    ? (
                      <>
                        <Spinner size="sm">
                          Loading...
                        </Spinner>
                        <span>
                          {' '}Loading
                        </span>
                      </>
                    )
                    : 'Charge'
                }
              </Button>
            </div>  
          </Col>
        </Row>
      </div>
    </>
  )
}
